// extracted by mini-css-extract-plugin
export default {"wrapper":"FreePythonClass_wrapper__yFsYF","card1":"FreePythonClass_card1__OXCV5","card2":"FreePythonClass_card2__2yizk"};